var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2624 12.0586V10.2889H19.341V15.5979C19.341 16.5564 18.4931 17.3675 17.5714 17.3675H2.23448C1.27593 17.3675 0.464844 16.5564 0.464844 15.5979V10.2889H7.54341V12.0586C7.54341 12.3904 7.80148 12.6485 8.13329 12.6485H11.6726C11.9675 12.6485 12.2624 12.3904 12.2624 12.0586ZM17.5714 4.39014C18.4931 4.39014 19.341 5.23809 19.341 6.15978V9.10918H0.464844V6.15978C0.464844 5.23809 1.27593 4.39014 2.23448 4.39014H5.18389V2.6205C5.18389 1.69881 5.99497 0.85086 6.95353 0.85086H12.8523C13.774 0.85086 14.622 1.69881 14.622 2.6205V4.39014H17.5714ZM12.2624 4.39014V3.21038H7.54341V4.39014H12.2624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/Job.36d293f98a61e3336a8fbd4602b567df.svg";
export { ForwardRef as ReactComponent };